export default function modal() {
  const container = document.querySelector('.js-modal');
  if (! container) return;
  const btns = document.querySelectorAll(`a[href='#${container.dataset.id}']`);

  btns.forEach(btn => {
    btn.addEventListener('click', event => {
      event.preventDefault();
      container.classList.add('is-active');
    })
  })
}